import angular from "angular";
import { directiveFactory } from "../angular-core";

export class EnterAsTabDirective implements ng.IDirective {
    static componentName: string = "enterAsTab";

    link = (scope: ng.IScope, element: JQLite) => {
        element.bind("keydown keypress", function (this: $TSFixMe, event: $TSFixMe) {
            if (event.which === 13) {
                event.preventDefault();
                var fields = $(this).parents("form:eq(0),body").find("input, textarea, select");
                var index = fields.index(this);
                const isShiftKeyDown = event.shiftKey;
                if (index > -1 && getNextIndex(index, isShiftKeyDown) < fields.length) {
                    fields.eq(getNextIndex(index, isShiftKeyDown)).focus();
                }
            }
        });

        function getNextIndex(index: $TSFixMe, isShiftKeyDown: $TSFixMe) {
            if (isShiftKeyDown) {
                return index - 1;
            } else {
                return index + 1;
            }
        }
    };
}

angular.module("topline.directives").directive(EnterAsTabDirective.componentName, directiveFactory(EnterAsTabDirective));